import { auth } from '../config/firebase';
import { signInWithEmailAndPassword, signOut, createUserWithEmailAndPassword, updateProfile, sendEmailVerification } from 'firebase/auth';
import { doc, setDoc, getDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../config/firebase';

export const loginEmployer = async (email, password) => {
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    return userCredential.user;
  } catch (error) {
    throw error;
  }
};

export const registerEmployer = async (email, password, firstName, lastName, companyName) => {
  const userCredential = await createUserWithEmailAndPassword(auth, email, password);
  const user = userCredential.user;

  await updateProfile(user, { displayName: `${firstName} ${lastName}` });

  // Force-refresh the ID token so the Firestore write below carries a valid token.
  await user.getIdToken(true);

  await setDoc(doc(db, 'users', user.uid), {
    email,
    displayName: `${firstName} ${lastName}`,
    firstName,
    lastName,
    role: 'employer',
    accessLevel: 'administrator',
    accountStatus: 'pending_email_verification',
    createdAt: serverTimestamp(),
    profile: {
      company: companyName,
      bio: '',
      skills: [],
      languages: ['en'],
      community: null,
      location: null,
      photoURL: null,
      role: 'employer',
    },
    preferences: { language: 'en', notifications: { email: true, push: true } },
    autoReply: { enabled: false, thresholdHours: 2 },
  }, { merge: true });

  await sendEmailVerification(user);

  return user;
};

export const checkEmailVerified = async () => {
  const user = auth.currentUser;
  if (!user) throw new Error('No user logged in');
  await user.reload();
  if (!user.emailVerified) {
    await signOut(auth);
    throw new Error('Email not verified. Please check your inbox.');
  }
  return user;
};

export const isEmailVerified = () => auth.currentUser?.emailVerified ?? false;

export const resendVerificationEmail = async () => {
  if (auth.currentUser) await sendEmailVerification(auth.currentUser);
};

export const reloadUser = async () => {
  if (auth.currentUser) await auth.currentUser.reload();
};

export const logoutEmployer = async () => {
  try {
    await signOut(auth);
  } catch (error) {
    throw error;
  }
};

export const getCurrentUser = () => {
  return auth.currentUser;
};

export const checkUserRole = async () => {
  const user = auth.currentUser;
  if (!user) throw new Error('No user logged in');
  const snap = await getDoc(doc(db, 'users', user.uid));
  const role = snap.data()?.role;
  if (role !== 'employer' && role !== 'admin') {
    await signOut(auth);
    throw new Error('role-denied');
  }
  return role;
};
